module.exports = __webpack_public_path__ + "manifest.json";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/manifest.json
// module id = 4028
// module chunks = 25